import { render, staticRenderFns } from "./top-nav.vue?vue&type=template&id=28aba05d&"
import script from "./top-nav.vue?vue&type=script&lang=js&"
export * from "./top-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports